module.exports = __webpack_public_path__ + "Roboto-Medium.894a2ede85a483bf9bed.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Medium.ttf
// module id = 304
// module chunks = 2